export default __webpack_public_path__ + "static/page-header-do-1-097a55becc6c652030d9ce5a3492d34c.png";